import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { CardContent, Typography } from '@material-ui/core';
import { AddCircle, Delete, RemoveCircle } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    main: {
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 16,
        color: theme.palette.secondary.main
    },
    title: {
        textTransform: 'uppercase',
        letterSpacing: 1.2,
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    subtitle: {
        fontSize: 14,
        opacity: 0.75,
        marginBottom: theme.spacing(3),
    },
    tableContainer: {
        width: '100%',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
    },
    table: {
        width: '100%',
        minWidth: 760,
        borderCollapse: 'separate',
        borderSpacing: '0 12px',
        [theme.breakpoints.down('sm')]: {
            minWidth: 0,
            borderSpacing: 0,
        },
    },
    tableHead: {
        textTransform: 'uppercase',
        letterSpacing: 0.8,
        fontSize: 12,
        opacity: 0.7,
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    row: {
        background: 'rgba(15, 16, 20, 0.35)',
        borderRadius: 12,
        boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.06)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 10px 18px rgba(10, 12, 18, 0.35)',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            marginBottom: theme.spacing(1.5),
            borderRadius: 12,
            overflow: 'hidden',
        },
    },
    cell: {
        padding: theme.spacing(1.2, 2),
        fontSize: 15,
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: theme.spacing(1),
            width: '100%',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            textAlign: 'right',
            '&::before': {
                content: 'attr(data-label)',
                textTransform: 'uppercase',
                letterSpacing: 0.8,
                opacity: 0.7,
                fontSize: 11,
                fontWeight: 600,
                textAlign: 'left',
                flex: '0 0 42%',
            },
        },
    },
    emailCell: {
        maxWidth: 280,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('sm')]: {
            maxWidth: 'none',
            overflow: 'visible',
            textOverflow: 'clip',
        },
    },
    cellFirst: {
        borderTopLeftRadius: 12,
        borderBottomLeftRadius: 12,
        [theme.breakpoints.down('sm')]: {
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 12,
        },
    },
    cellLast: {
        borderTopRightRadius: 12,
        borderBottomRightRadius: 12,
        [theme.breakpoints.down('sm')]: {
            borderTopRightRadius: 0,
            borderBottomLeftRadius: 12,
        },
    },
    labelPill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        borderRadius: 999,
        background: 'rgba(255, 255, 255, 0.08)',
        color: '#fff',
        fontSize: 13,
    },
});

class TeamMembers extends Component {

    componentDidMount() {
        this.getUserDetails();
    }

    getUserDetails() {
        this.props.dispatch({
            type: 'FETCH_TEAM_USERS'
        })
    }

    handleCaptainChange = (id, clearanceId) => {
        this.props.dispatch({
            type: 'UPDATE_CAPTAIN',
            payload: { id, clearanceId }
        })
    }

    handleDeleteTeamMember = (id, name) => {

        MySwal.fire({
            title: `Delete ${name} from your team?`,
            text: `${name} can register again with a valid Team Access Code.`,
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.value) {
                this.props.dispatch({
                    type: 'DELETE_TEAM_MEMBER',
                    payload: id
                })
                Swal.fire(
                    'Deleted!',
                    `${name} has been deleted from your team.`,
                    'success'
                )
            }
        })
    }

    render() {

        const { classes } = this.props

        let teamList = this.props.teamUsers.map(member => {

            let captain = false;

            if (this.props.user.id === member.id) {
                captain = null;
            } else if (member.clearance_id == 2) {
                captain = true;
            }

            return (
                <tr className={classes.row} key={member.id}>
                    <td data-label="First Name" className={`${classes.cell} ${classes.cellFirst}`}>{member.first_name}</td>
                    <td data-label="Last Name" className={classes.cell}>{member.last_name}</td>
                    <td data-label="Email" className={`${classes.cell} ${classes.emailCell}`} title={member.username}>{member.username}</td>
                    {captain == true && (
                        <td data-label="Admin Access" className={classes.cell}>
                            <Button variant="contained" color="secondary" onClick={() => this.handleCaptainChange(member.id, member.clearance_id)}>
                                <RemoveCircle style={{ marginRight: 3 }} />Revoke
                            </Button>
                        </td>
                    )}
                    {captain == false && (
                        <td data-label="Admin Access" className={classes.cell}>
                            <Button variant="contained" color="primary" style={{ backgroundColor: this.props.user.color }} onClick={() => this.handleCaptainChange(member.id, member.clearance_id)}>
                                <AddCircle style={{ marginRight: 3 }} />Add
                            </Button>
                        </td>
                    )}
                    {captain == null && (
                        <td data-label="Admin Access" className={classes.cell}>
                            <span className={classes.labelPill}>Team Captain</span>
                        </td>
                    )}
                    {captain == true && (
                        <td data-label="Delete" className={`${classes.cell} ${classes.cellLast}`}>
                            <Button variant="contained" color="primary" style={{ backgroundColor: this.props.user.color }} onClick={() => this.handleDeleteTeamMember(member.id, member.first_name)}>
                                <Delete style={{ marginRight: 3 }} />Delete
                            </Button>
                        </td>
                    )}
                    {captain == false && (
                        <td data-label="Delete" className={`${classes.cell} ${classes.cellLast}`}>
                            <Button variant="contained" color="primary" style={{ backgroundColor: this.props.user.color }} onClick={() => this.handleDeleteTeamMember(member.id, member.first_name)}>
                                <Delete style={{ marginRight: 3 }} />Delete
                            </Button>
                        </td>
                    )}
                    {captain == null && <td data-label="Delete" className={`${classes.cell} ${classes.cellLast}`}></td>}
                </tr>
            )
        })

        return (
            <CardContent>
                <div className={classes.main}>
                    <h2 className={classes.title}>Your Team</h2>
                    <Typography className={classes.subtitle}>Manage access and roles for teammates in one place.</Typography>
                    <div className={classes.tableContainer}>
                        <table className={`${classes.table} center`}>
                            <thead className={classes.tableHead}>
                                <tr>
                                    <th className={classes.cell}>First Name</th>
                                    <th className={classes.cell}>Last Name</th>
                                    <th className={classes.cell}>Email</th>
                                    <th className={classes.cell}>Admin Access</th>
                                    <th className={classes.cell}>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {teamList}
                            </tbody>
                        </table>
                    </div>
                </div>
            </CardContent>
        )

    }

}

const mapStateToProps = state => ({
    user: state.user,
    team: state.team,
    teamUsers: state.teamUsers
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(TeamMembers)));
